
<ui-panel panelTitle="Checkbox Columns"
  [panelHeaderConfig]="panelHeaderConfig"
  [(additionalActionsFormValues)]="addActFormValues"
>
  <app-checkbox-columns
    [checkboxes]="permissions"
    [numColumns]="addActFormValues.numCols"
    [readOnly]="addActFormValues.readOnly"
    [orderBy]="addActFormValues.orderBy"
    [columnWidth]="addActFormValues.width"


  ></app-checkbox-columns>
  <hr />
  <div>Columns: <b>{{addActFormValues.numCols}}</b>, Column Width: <b>{{addActFormValues.width}}</b>,  Read only: <b>{{addActFormValues.readOnly}}</b>,  Order by: <b>{{addActFormValues.orderBy}}</b></div>
</ui-panel>
